import { api } from "./api";
import { getAttributionV2 } from "./utm";

/**
 * Dev-only warning helper. In production, tracking failures are silent
 * by design (an adblocker user shouldn't see console noise). In dev, we
 * surface them so a misconfigured endpoint is debuggable.
 */
const warnInDev = (msg, err) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(`[track] ${msg}`, err);
  }
};

/**
 * Fire-and-forget activity event. Never throws; tracking failures must
 * not disrupt the user experience.
 *
 * Phase 2 revenue tracking — EVERY event auto-carries the durable
 * (src, campaign) pair pulled from `am_attribution_v1` localStorage.
 * The backend `/api/activity` handler promotes these into the event's
 * metadata so the admin Sources dashboard can aggregate funnel counts
 * by channel without each call-site having to remember to pass them.
 * Caller-supplied src/campaign (rare) wins over the durable value.
 */
export const trackEvent = (event_type, extra = {}) => {
  try {
    const v2 = (() => {
      try {
        return getAttributionV2();
      } catch {
        return { src: undefined, campaign: undefined };
      }
    })();
    const payload = {
      event_type,
      route: typeof window !== "undefined" ? window.location.pathname + window.location.hash : null,
      src: v2.src,
      campaign: v2.campaign || undefined,
      ...extra,
    };
    api.post("/activity", payload).catch((e) => warnInDev("activity post failed", e));
  } catch (e) {
    warnInDev("trackEvent threw", e);
  }
};

/**
 * Log a Reciprocity fulfillment event so the admin dashboard can confirm
 * the promised return actually rendered on the user's screen.
 */
export const trackReciprocity = (fulfillment_type, extra = {}) => {
  try {
    const payload = {
      event_type: `reciprocity_${fulfillment_type}`,
      fulfillment_type,
      route: typeof window !== "undefined" ? window.location.pathname + window.location.hash : null,
      ...extra,
    };
    api.post("/reciprocity/events", payload).catch((e) => warnInDev("reciprocity post failed", e));
  } catch (e) {
    warnInDev("trackReciprocity threw", e);
  }
};
